import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketHistoriesComponent } from './ticket-histories.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CheckBoxModule } from '../checkbox/checkbox.module';
import { ModalModule } from '../modal/modal.module';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from '../tooltip/tooltip.module';
import { TitleModule } from '../title/title.module';
import { TicketSegmentComponent } from './ticket-segment/ticket-segment.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

@NgModule({
  declarations: [
    TicketHistoriesComponent,
    TicketSegmentComponent,
  ],
  imports: [
    CommonModule,
    TitleModule,
    SharedModule,
    CheckBoxModule,
    FormsModule,
    ModalModule,
    TooltipModule,
    PipesModule
  ],
  exports: [TicketHistoriesComponent],
})
export class TicketHistoriesModule {}
